import React from 'react';
import { Image as ImageIcon, UploadSimple } from '@phosphor-icons/react';

export function BrandingEditor({
  primaryColor,
  onPrimaryColorChange,
  logoPreview,
  currentLogoUrl,
  onLogoChange,
  disabled = false,
}) {
  const displayLogo = logoPreview || currentLogoUrl;

  return (
    <div className="space-y-5">
      <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-slate-200 bg-[#F7F9FC] px-4 py-5">
        {displayLogo ? (
          <img
            src={displayLogo}
            alt="Company logo preview"
            className="h-16 max-w-[200px] rounded-lg object-contain"
          />
        ) : (
          <div className="flex h-16 w-16 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-400">
            <ImageIcon size={28} weight="duotone" aria-hidden="true" />
          </div>
        )}
        <label className="inline-flex cursor-pointer items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-[var(--brand-primary,#1A428A)] shadow-sm ring-1 ring-slate-200 transition hover:scale-105">
          <UploadSimple size={14} weight="bold" aria-hidden="true" />
          <span>{displayLogo ? 'Change logo' : 'Upload logo'}</span>
          <input
            type="file"
            accept="image/png,image/jpeg,image/webp"
            className="sr-only"
            onChange={onLogoChange}
            disabled={disabled}
          />
        </label>
        <p className="text-[11px] text-slate-500">PNG, JPEG, or WebP up to 2 MB</p>
      </div>

      <div>
        <label
          htmlFor="brand-color"
          className="mb-2 block font-display text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500"
        >
          Brand color
        </label>
        <div className="flex items-center gap-3">
          <input
            id="brand-color"
            type="color"
            value={primaryColor}
            onChange={(event) => onPrimaryColorChange(event.target.value.toUpperCase())}
            disabled={disabled}
            className="h-11 w-14 cursor-pointer rounded-lg border border-slate-200 bg-white"
          />
          <input
            type="text"
            value={primaryColor}
            onChange={(event) => onPrimaryColorChange(event.target.value)}
            disabled={disabled}
            className="h-11 flex-1 rounded-xl border border-slate-200 px-3 text-sm uppercase text-slate-800 outline-none transition focus:border-[var(--brand-primary,#1A428A)] focus:ring-2 focus:ring-[var(--brand-primary,#1A428A)]/15"
          />
        </div>
      </div>
    </div>
  );
}
